import { render } from "./ImageUpload.vue?vue&type=template&id=f5d15bda"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"
script.render = render

export default script